module.exports = __webpack_public_path__ + "img/aizq.d99ef9d8.svg";